// extracted by mini-css-extract-plugin
export var locationCard = "_rf-0";